






















































import DocumentLink from '@/components/DocumentLink'

export default {
    name: 'InfoBox'

    components:
        DocumentLink: DocumentLink

    props: ['document']

    computed:
        textBoxClass: ->
            'uk-background-muted': @fields.background_color is 'standard' or @fields.background_color is 'gedeckt'
            'uk-background-secondary uk-light': @fields.background_color is 'sekundär'
            'uk-background-primary': @fields.background_color is 'primär'
        gridClass: ->
            'uk-flex-row-reverse': @fields.image_position is 'rechts'
        imageSrc: ->
            if @$parent.isPageWidth
                @fields.image.klein.url
            else
                @fields.image.url
        imageSrcSet: ->
            unless @fields.image or @$parent.isPageWidth then return
            @fields.image.url + ', ' + @fields.image.klein.url

    data: ->
        fields: @defaultFields()

    methods:
        defaultFields: ->
            image: []
            image_position: 'links'
            background_color: 'standard'
            title: []
            subtitle: []
            text: []
            button_title: []
            button_link: []
        
        setContent: (document) ->
            fields =
                image: document.image
                image_position: document.image_position
                background_color: document.background_color1
                title: document.title
                subtitle: document.subtitle
                text: document.text
                button_title: document.button_title
                button_link: document.button_link
            $.extend @fields, fields

    created: ->
        @setContent @document
}
